import type { EntityViewProps } from '../../types';
import { ArticulosEntity } from './ArticulosEntity';

export function ServiciosEntity(props: EntityViewProps) {
  return <ArticulosEntity {...props} cotizable="NO" entitySingular="Servicio" />;
}
